"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var buildState = function buildState(store, modules) {
  var state = {};
  store.map(function (obj) {
    state = _objectSpread(_objectSpread({}, state), obj.state);
  });
  modules.map(function (module) {
    if (module.extendStore) {
      var _module$extendStore, _module$extendStore$d;

      (_module$extendStore = module.extendStore) === null || _module$extendStore === void 0 ? void 0 : (_module$extendStore$d = _module$extendStore.data) === null || _module$extendStore$d === void 0 ? void 0 : _module$extendStore$d.map(function (item) {
        state = _objectSpread(_objectSpread({}, state), item.state);
      });
    }
  });

  var initialState = _objectSpread({}, state);

  return initialState;
};

var _default = buildState;
exports["default"] = _default;
module.exports = exports.default;